import apiClient from '../../../lib/apiClient';

const manualEditorService = {
  async generateDesign(payload) {
    return apiClient.request('/design/generate', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },

  async listDesigns(sessionId) {
    const suffix = sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : '';
    return apiClient.request(`/designs${suffix}`, { auth: Boolean(!sessionId) });
  },

  async getDesign(id) {
    return apiClient.request(`/designs/${id}`);
  },

  async createManualDesign(payload = {}) {
    const base = {
      prompt: payload.prompt || 'Arte manual',
      type: payload.type || 'design',
      size: payload.size || '1:1',
      platform: payload.platform || 'instagram',
      format: payload.format || 'standard',
      media_type: payload.media_type || 'photo',
      ...(payload.session_id ? { session_id: payload.session_id } : {}),
    };

    return this.generateDesign(base);
  },

  async updateCanvas(id, canvasJson, options = {}) {
    const body = {
      canvas_json: canvasJson,
    };

    if (options.previewImage) {
      body.preview_image = options.previewImage;
    }

    if (options.previewThumb) {
      body.preview_thumb = options.previewThumb;
    }

    if (options.prompt) {
      body.prompt = options.prompt;
    }

    return apiClient.request(`/designs/${id}/canvas`, {
      method: 'PUT',
      body: JSON.stringify(body)
    });
  },

  async duplicate(id) {
    return apiClient.request(`/designs/${id}/duplicate`, { method: 'POST' });
  },

  async destroy(id) {
    return apiClient.request(`/designs/${id}`, { method: 'DELETE' });
  },

  async searchMedia(query, mediaType = 'photo', orientation = '') {
    const params = new URLSearchParams();
    params.set('q', query || 'marketing creative inspiration');
    params.set('type', mediaType || 'photo');
    params.set('page', '1');
    if (orientation) {
      params.set('orientation', orientation);
    }

    return apiClient.request(`/media/search?${params.toString()}`, { auth: false });
  },
};

export default manualEditorService;
